import axios from "axios";

window.addEventListener("DOMContentLoaded", () => {
	let create_button = document.getElementById("create_new_post_button");
	if (create_button) {
		create_button.addEventListener("click", () => {
			let post_title = window.prompt("Please give a title to your blogpost");
			if (post_title) {
				let form_data = new FormData();
				form_data.append("action", "create_new_post");
				form_data.append("title", post_title);
				axios.post(ajaxurl, form_data)
					.then((res) => {
						window.location.href = `https://thedotgood.net/edit-your-blog-post/?post=${res.data}`;
					})
					.catch((err) => {
						alert(err);
					});
			}
		});
	}
});
